import { Card, CardContent, CardHeader, CardTitle } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { TabelaDeSolicitacoes } from "./TabelaDeSolicitacoes";

/** Pedidos LGPD do titular na ficha — reset e exclusão só são executáveis a partir de um deles. */
export function SolicitacoesDoUsuario({ userId }: { userId: string }) {
  const { data } = trpc.admin.lgpd.list.useQuery({ userId });
  return (
    <Card className="border-admin-200">
      <CardHeader>
        <CardTitle>Solicitações LGPD</CardTitle>
      </CardHeader>
      <CardContent className="overflow-x-auto p-0">
        <TabelaDeSolicitacoes itens={data ?? []} mostrarTitular={false} />
      </CardContent>
    </Card>
  );
}
